import { Navigate, useLocation } from "react-router-dom";
import { getAdminToken } from "@/lib/api";

// Client-side gate only — the real enforcement is server-side (every admin
// endpoint requires a valid JWT, see backend/auth.py). This just avoids
// flashing the dashboard before an inevitable 401 redirect.
export function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!getAdminToken()) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
